import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import classNames from 'classnames';
import headerLogo from 'ml-digital-theme-styles/images/farmers/farmers-logo.svg';
import headerLogoQnB from 'ml-digital-theme-styles/images/farmers/farmersqnb-logo.svg';

// eslint-disable-next-line import/no-unresolved
import messages from './CustomHeaderComponent.messages';
import styles from './CustomHeaderComponent.module.scss';
import appConfig from 'app-config';

const CustomHeaderComponent = (props) => {
    const isQnB = appConfig.portalCode === 'QB';
    const translator = useTranslator();
    const { showCustomHeader } = props;

    return (
        <>
            <nav className={styles.qbMainNav}>
                <div className={styles.containerFluid}>
                    <div className={styles.qbMainNav__farmersLogo}>
                        <img src={isQnB ? headerLogoQnB : headerLogo} alt={translator(messages.header)} />
                    </div>
                    <div className={styles.qbMainNav__secondaryMenuItems}>
                        <ul>
                            <li>
                                <a href="/faq" target="_blank" className={styles.menuItemLabel}>
                                    <span className={styles.iconPadding} />
                                    <span>
                                        {translator(messages.faq)}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            {showCustomHeader && <header className={isQnB ? styles.qbProgressHeaderNone : styles.qbProgressHeader} />}
        </>
    );
};

CustomHeaderComponent.defaultProps = {
    showCustomHeader: true
};

CustomHeaderComponent.propTypes = {
    showCustomHeader: PropTypes.bool

};
export default CustomHeaderComponent;
